import httpClient from '~/lib/http-client';
import type {
  Project,
  ProjectListItem,
  CreateProjectRequest,
  UpdateProjectRequest,
  SharedProject,
} from '@shared/types/project';
import type { ChatListItem } from '@shared/types/chat';

export async function apiGetProjects(): Promise<ProjectListItem[]> {
  const { data } = await httpClient.get<ProjectListItem[]>('/api/projects');
  return data;
}

export async function apiGetProject(id: string): Promise<Project> {
  const { data } = await httpClient.get<Project>(`/api/projects/${id}`);
  return data;
}

export async function apiCreateProject(req: CreateProjectRequest): Promise<Project> {
  const { data } = await httpClient.post<Project>('/api/projects', req);
  return data;
}

export async function apiUpdateProject(id: string, req: UpdateProjectRequest): Promise<Project> {
  const { data } = await httpClient.put<Project>(`/api/projects/${id}`, req);
  return data;
}

export async function apiDeleteProject(id: string): Promise<void> {
  await httpClient.delete(`/api/projects/${id}`);
}

export async function apiGetProjectChats(id: string): Promise<ChatListItem[]> {
  const { data } = await httpClient.get<ChatListItem[]>(`/api/projects/${id}/chats`);
  return data;
}

export async function apiRemoveChatFromProject(projectId: string, chatId: string): Promise<void> {
  await httpClient.delete(`/api/projects/${projectId}/chats/${chatId}`);
}

export async function apiGetSharedProject(id: string): Promise<SharedProject> {
  const { data } = await httpClient.get<SharedProject>(`/api/shared/project/${id}`);
  return data;
}

export async function apiForkProject(id: string): Promise<Project> {
  const { data } = await httpClient.post<Project>(`/api/shared/project/${id}/fork`);
  return data;
}
